
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  RuleResourcesInner,
} from '../models';
import {
    RuleResourcesInnerFromJSON,
    RuleResourcesInnerToJSON,
} from '../models';

export interface RulesRequest {
    profileId?: string;
    vertical?: RulesVerticalEnum;
}

/**
 * 
 */
export class PublicValidationRulesApi extends runtime.BaseAPI {

    /**
     * Returns profile rules
          */
    async rulesRaw(requestParameters: RulesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<RuleResourcesInner>>> {
        const queryParameters: any = {};

        if (requestParameters['profileId'] != null) {
            queryParameters['profileId'] = requestParameters['profileId'];
        }

        if (requestParameters['vertical'] != null) {
            queryParameters['vertical'] = requestParameters['vertical'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<RuleResourcesInner>>({
            path: `/profile/public-api/rules`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(RuleResourcesInnerFromJSON);
        return response;
    }

    /**
     * Returns profile rules
          */
    async rules(requestParameters: RulesRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<RuleResourcesInner>> {
        const response = await this.rulesRaw(requestParameters, initOverrides);
        return response._data;
    }

}

/**
 * @export
 */
export const RulesVerticalEnum = {
    Freelancer: 'FREELANCER',
    Strategy: 'STRATEGY'
} as const;
export type RulesVerticalEnum = typeof RulesVerticalEnum[keyof typeof RulesVerticalEnum];
